import script from "./EntityCrud.vue?vue&type=script&lang=js"
export * from "./EntityCrud.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__